import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy /orgs/$slug URL kept around because Stripe Checkout success URLs
// generated before the rename still redirect here. Forwards to the new
// /organizations/$slug route preserving the slug + query string.
export const Route = createFileRoute(
  "/_authenticated/(wonda)/_wonda/orgs/$slug",
)({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/organizations/$slug",
      params: { slug: params.slug },
      search,
    });
  },
});
